import React, { useState } from "react";
import "isomorphic-fetch";
import cx from "classnames";
import { Modal, Fade } from "@material-ui/core";
import { Backdrop } from "src/components/backdrop";
import Div100vh from "src/components/div100vh";
import { useStoreContext } from "src/context/siteContext";

import * as styles from "./waitlist.module.css";

export const Waitlist = ({
  open,
  toggle,
  accountId,
  message,
  buttonText,
  variantId,
}: {
  open: boolean;
  toggle: () => void;
  accountId: string;
  message: string;
  buttonText: string;
  variantId: number;
}) => {
  const { noticeBarVisible } = useStoreContext();
  const [success, setSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget;
    const { email } = form.elements;

    fetch("/.netlify/functions/back-in-stock", {
      method: "POST",
      body: JSON.stringify({
        accountId,
        email: email.value,
        variant: variantId,
        platform: "shopify",
      }),
    }).then((response) => {
      setSuccess(true);
    });
  };
  return (
    <>
      <Modal
        anchor="left"
        open={open}
        onClose={() => toggle()}
        closeAfterTransition={true}
        BackdropComponent={Backdrop}
        BackdropProps={{ active: open, toggle: toggle }}
      >
        <Fade
          in={open}
          timeout={{
            enter: 600,
            exit: 600,
          }}
        >
          <Div100vh
            className={cx(
              styles.waitlist,
              noticeBarVisible ? styles.noticeBarVisible : ""
            )}
            role="presentation"
          >
            <div className={cx(styles.inner)}>
              <button className={styles.closeButton} onClick={toggle}>
                X <span className="underline-on-hover">Close</span>
              </button>
              <div className={styles.content}>
                {!success ? (
                  <form
                    onSubmit={(e) => handleSubmit(e)}
                    className={styles.form}
                  >
                    <label>
                      Email
                      <input
                        name="email"
                        className={cx(styles.emailInput)}
                        placeholder="Your email address"
                        type="email"
                        required={true}
                        aria-label="Your email address"
                      />
                    </label>
                    <button type="submit" className={styles.submitButton}>
                      <span>{buttonText}</span>
                    </button>
                  </form>
                ) : (
                  <p className={cx(styles.message)}>{message}</p>
                )}
              </div>
            </div>
          </Div100vh>
        </Fade>
      </Modal>
    </>
  );
};
